<template lang="pug">
    v-footer(class="mx-auto" style="background-color:#fafafa;")
        //- v-spacer
        //span &copy; {{ new Date().getFullYear() }} - IT Application
    
</template>

<script>
export default {
    
}
</script>

<style>

</style>


